import React from 'react';
import { getLanguageTexts, getSelectedLanguage, languageOptions, setSelectedLanguage } from '../language';

class CandidateLanguageSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLanguage: getSelectedLanguage()
        };
    }

    componentDidMount() {
        window.addEventListener('candidate_language_change', this.handleExternalChange);
    }

    componentWillUnmount() {
        window.removeEventListener('candidate_language_change', this.handleExternalChange);
    }

    handleExternalChange = (event) => {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    handleChange = (event) => {
        const selectedLanguage = setSelectedLanguage(event.target.value);
        this.setState({ selectedLanguage });
        if (this.props.onChange) {
            this.props.onChange(selectedLanguage);
        }
    }

    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);

        return (
            <div className={this.props.className || 'candidate-language-selector'}>
                <label htmlFor={this.props.id || 'candidate-language-select'}>
                    <i className="mdi mdi-web"></i>
                    {this.props.showLabel !== false && <span>{t.language_label}</span>}
                </label>
                <select
                    id={this.props.id || 'candidate-language-select'}
                    value={this.state.selectedLanguage}
                    onChange={this.handleChange}
                    aria-label={t.language_label}>
                    {languageOptions.map((item) => (
                        <option key={item.value} value={item.value}>{item.value}</option>
                    ))}
                </select>
            </div>
        );
    }
}

export default CandidateLanguageSelector;
